// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html, body, #root {\n\theight: 100%;\n\tmargin: 0px;\n}", ""]);
// Exports
module.exports = exports;
